pageId = 'teams-dashboards-delay_statistics-index'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  initInfiniteLoadMembersStatistics($page)

$ ->
  tower.stack.on 'pageunload', (e) ->
    unbindInfiniteLoadMembersStatisitcs()

initInfiniteLoadMembersStatistics = ($scope) ->
  $table = $scope.find('.members-statistics-table')
  $loading = $table.find('.members-statistics-table-loading')
  hasNextPage = $table.data('has-next-page')

  return unless hasNextPage

  memberStatMaxTodosCount = parseInt($table.data('member-stat-max-todos-count'))
  lock = false

  $(window).on "scroll.loadMembersStatistics.#{pageId}", ->
    return if lock || document.body.clientHeight - window.scrollY - window.innerHeight > 80

    lock = true
    $loading.show()
    $.ajax
      url: location.href
      data:
        paginate_member_guid: $table.find('tr.member-statistics:last-child').data('member-guid')
        member_stat_max_todos_count: memberStatMaxTodosCount
      method: 'get'
      dataType: 'json'
    .done (data) ->
      $table.find('tbody').append(data.members_stat_html)
      $loading.hide()
      if data.has_next_page && data.members_stat_html.trim().length > 0
        lock = false
      else
        unbindInfiniteLoadMembersStatisitcs()

unbindInfiniteLoadMembersStatisitcs = ->
  $(window).off "scroll.loadMembersStatistics.#{pageId}"
